export const SignRequestDocumentSigningStatus = {
    NoSignatureRequired: 0,
    PendingSigning: 1,
    SignedPrimary: 2,
    SignedAll: 4
};
